import { Route, Routes } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';
import { CorrespondencePackagePage } from '@/pages/correspondence';

import { CorrespondenceInbox } from './inbox';

export const CorrespondenceRoutes = () => {
  const { matterId } = useMatter();

  return (
    <Routes>
      <Route path="/" element={<CorrespondenceInbox matterId={matterId} />} />
      <Route
        path="/:package_id"
        element={<CorrespondencePackagePage matterId={matterId} />}
      />
    </Routes>
  );
};
